import React from 'react'

import type { PicksContentItem } from '../../../../generated/frontend'
import { Link } from '../../../../shared/components/Link'
import styles from './InlineArticleLinks.module.scss'

export const InlineArticleLinks: React.FC<Props> = ({ sectionItem, onClickHandler }) => {
  const { title } = sectionItem
  return (
    <ul className={styles.list}>
      {sectionItem.inlineArticles.map(({ href, text }, index) => (
        <li key={`${href}-${index}`}>
          <Link
            appearance="primary"
            href={href}
            includeIcon
            textStyle="sb-text-heading-small"
            target="_blank"
            rel="nofollow noopener noreferrer"
            type="NavigationLink"
            onClick={() => onClickHandler(text, href, title)}
          >
            {text}
          </Link>
        </li>
      ))}
    </ul>
  )
}

///////// IMPLEMENTATION /////////

interface Props {
  sectionItem: PicksContentItem
  onClickHandler: (text: string, href: string, title: string) => void
}
